import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after, beforeLabel, afterLabel, alt, sliderLabel }) => {
  const [pos, setPos] = useState(50);

  return (
    <div className="relative w-full aspect-[3/4] overflow-hidden bg-slate-200 select-none shadow-2xl" data-testid="before-after-slider">
      <img src={after} alt={`${alt} — ${afterLabel}`} className="absolute inset-0 w-full h-full object-cover" draggable="false" />
      <img
        src={before}
        alt={`${alt} — ${beforeLabel}`}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable="false"
      />
      <span className="absolute top-4 left-4 bg-blue-900/90 text-white text-xs font-bold tracking-widest uppercase px-3 py-1.5" data-testid="before-label">
        {beforeLabel}
      </span>
      <span className="absolute top-4 right-4 bg-emerald-600/90 text-white text-xs font-bold tracking-widest uppercase px-3 py-1.5" data-testid="after-label">
        {afterLabel}
      </span>
      <div className="absolute inset-y-0 w-0.5 bg-white pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-blue-900">
          <MoveHorizontal className="w-5 h-5" />
        </div>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label={sliderLabel}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
        data-testid="before-after-range"
      />
    </div>
  );
};
